/*
 * Élodie Paris - header menu hover behaviour (desktop mouse only).
 *
 *  - Hover a menu word: the line appears and its submenu opens at once (native Horizon).
 *  - Move the pointer away from the word: the submenu STAYS OPEN. Nothing closes it while the
 *    pointer travels to the panel, roams the header, goes down the page or scrolls.
 *  - The ONLY thing that closes it is the pointer going over another menu word: the open
 *    submenu closes and that word's submenu opens at once (same behaviour again).
 *  - Keyboard behaviour (Tab, Escape) is untouched and takes priority over the mouse rule.
 *
 * Two layers, so it does not matter WHAT would otherwise close the submenu:
 *  1. Horizon's "pointerleave" on a menu item (its normal closer) is stopped for mouse pointers.
 *  2. Safety net: if the submenu the pointer last opened is closed by anything else while the
 *     pointer has not gone to another menu word, it is re-opened in the same frame.
 */
(function () {
  'use strict';

  var ITEM = 'header-menu .menu-list__list-item';

  // The menu item the mouse last opened. null = nothing to keep open (keyboard, Escape, other word).
  var wanted = null;
  var reopenCount = 0;
  var reopenWindowStart = 0;

  function isMouse(event) {
    return !event.pointerType || event.pointerType === 'mouse';
  }

  function hasSubmenu(item) {
    return Boolean(item && item.querySelector(':scope > .menu-list__submenu'));
  }

  function anyExpanded() {
    return Boolean(document.querySelector(ITEM + ' [aria-expanded="true"]'));
  }

  // Layer 1: the mouse leaving a menu word / its panel must not close the panel.
  document.addEventListener(
    'pointerleave',
    function (event) {
      if (!isMouse(event)) return;
      var item = event.target;
      if (!(item instanceof Element) || !item.matches(ITEM) || !hasSubmenu(item)) return;
      event.stopPropagation();
    },
    true
  );

  // Remember which word the mouse is on. Another word replaces it (and Horizon closes the old one).
  document.addEventListener(
    'pointerenter',
    function (event) {
      if (!isMouse(event)) return;
      var item = event.target;
      if (item instanceof Element && item.matches(ITEM)) wanted = item;
    },
    true
  );

  // Keyboard users are in charge: Escape / Tab / focus movement must be able to close it.
  document.addEventListener(
    'keydown',
    function () {
      wanted = null;
    },
    true
  );
  document.addEventListener(
    'focusin',
    function (event) {
      if (event.target instanceof Element && event.target.closest('header-menu')) wanted = null;
    },
    true
  );

  // Layer 2: safety net against any other closer.
  function reopen(item) {
    var now = Date.now();
    if (now - reopenWindowStart > 300) {
      reopenWindowStart = now;
      reopenCount = 0;
    }
    if (++reopenCount > 3) return; // never fight the page in a loop

    if (item !== wanted || !document.contains(item) || anyExpanded()) return;
    item.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false, pointerType: 'mouse' }));
  }

  new MutationObserver(function (records) {
    if (!wanted || !hasSubmenu(wanted)) return;

    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      var target = record.target;
      if (!(target instanceof Element)) continue;
      if (record.oldValue !== 'true' || target.getAttribute('aria-expanded') !== 'false') continue;

      var item = target.closest(ITEM);
      if (item && item === wanted) {
        reopen(item);
        return;
      }
    }
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-expanded'],
    attributeOldValue: true,
  });
})();